export const scrollToSection = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -64, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
